<template>
  <b-form @submit.prevent="handleSubmitFilter">
    <card class="data-card">
      <b-row no-gutters>
        <b-col no-gutters>
          <h2 class="card-header p-0 card-header-text pb-3 text-right">
            {{ title }}
          </h2>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col no-gutters>
          <BaseDatePicker @ChangeDateFilter="handleFilterDate" />
        </b-col>
      </b-row>
      <b-row class="justify-content-between">
        <b-col md="4" class="d-flex align-items-center mt-5" v-if="asset">
          <span>ارز:</span>
          <BaseSelect
            class="w-100 mr-4"
            label="symbol"
            :options="fromAssets"
            @onSelectValue="handleSelectAssetlValue"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-center mt-5" v-if="from">
          <span>از:</span>
          <BaseSelect
            class="w-100 mr-4"
            label="symbol"
            :options="fromAssets"
            @onSelectValue="handleSelectFromSymbolValue"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-center mt-5" v-if="to">
          <span>به:</span>
          <BaseSelect
            class="w-100 mr-4"
            label="symbol"
            :options="toAssets"
            @onSelectValue="handleSelectToSymbolValue"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-center mt-5">
          <span>تعداد:</span>
          <b-form-input
            class="w-100 mr-4"
            v-model.number="filterData.pageSize"
            type="number"
            min="1"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col no-gutters class="mt-5">
          <b-button
            size="sm"
            class="p-2 pl-4 pr-4"
            type="submit"
            variant="primary"
            >اعمال فیلتر</b-button
          >
        </b-col>
      </b-row>
    </card>
  </b-form>
</template>
<script>
import BaseDatePicker from "./Inputs/BaseDatePicker";
import BaseSelect from "./Inputs/BaseSelect";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },

    fromAssets: {
      type: Array,
      default: () => [],
    },

    toAssets: {
      type: Array,
      default: () => [],
    },

    asset: {
      type: Boolean,
      default: false,
    },

    from: {
      type: Boolean,
      default: false,
    },

    to: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseDatePicker,
    BaseSelect,
  },

  data() {
    return {
      filterData: {
        fromDate: "",
        toDate: "",
        fromSymbol: "",
        toSymbol: "",
        symbol: "",
        pageSize: 25,
      },
    };
  },

  methods: {
    handleFilterDate(range) {
      this.filterData.fromDate = "";
      this.filterData.toDate = "";
      this.filterData.fromDate = range[0];
      if (range[1]) {
        this.filterData.toDate = range[1];
      }
    },

    handleSelectFromSymbolValue(value) {
      this.filterData.fromSymbol = "";
      this.filterData.fromSymbol = value.symbol;
    },

    handleSelectToSymbolValue(value) {
      this.filterData.toSymbol = "";
      this.filterData.toSymbol = value.symbol;
    },

    handleSelectAssetlValue(value) {
      this.filterData.symbol = "";
      this.filterData.symbol = value.symbol;
    },

    handleSubmitFilter() {
      this.$emit("onSubmitFilter", this.filterData);
    },
  },
};
</script>
<style lang="scss" scoped></style>
